export default "__VITE_ASSET__CIFnVnts__"